import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { safeJsonLd } from "@/lib/structured-data";
import { getMidwestStructuredData } from "@/lib/structured-data/midwest";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { Footer } from "@/components/site/Footer";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const ValueProps = lazy(() => import("@/components/site/ValueProps").then(m => ({ default: m.ValueProps })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const DoctorBio = lazy(() => import("@/components/site/DoctorBio").then(m => ({ default: m.DoctorBio })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMapMidwest = lazy(() => import("@/components/site/LocationsMapMidwest").then(m => ({ default: m.LocationsMapMidwest })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/restore-midwest")({
  head: () => ({
    // A paid landing page with the home page's content (6-gram overlap 0.84 to
    // 1.0 on 16 Oct 2026) and no organic clicks in 90 days. The canonical
    // points at the home page so search signals consolidate there. Ads are
    // not affected: Google Ads does not read the canonical.
    links: [{ rel: "canonical", href: "https://restorehair.com/" }],
    meta: [
      { title: "Get Your Hair Back | RESTORE® Hair Transplants — Midwest" },
      {
        name: "description",
        content:
          "Restore your confidence with the top hair restoration team serving the Midwest. Over 20,000 procedures.",
      },
      { property: "og:title", content: "Get Your Hair Back | RESTORE® Hair Transplants — Midwest" },
      {
        property: "og:description",
        content:
          "Top hair restoration team trusted by celebrities, athletes & everyday guys. Soft, natural, undetectable results.",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({ "@graph": getMidwestStructuredData() }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <Hero />
        <NorwoodQuiz />
        <Suspense fallback={null}>
          <ValueProps hideEyebrowMobile />
          <Results hideEyebrowMobile />
          <Reviews hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy />
          <Guarantee />
          <Pricing />
          <DoctorBio />
          <Surgeons />
          <DoctorsGrid />
          <LocationsMapMidwest />
          <VirtualConsult />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}